import styled from "@emotion/styled/macro";
import { NavLink } from "react-router-dom";

export const SiteNavLink = styled(NavLink)`
  color: #fff;
`;
